import { useTranslation } from 'react-i18next';

import useBem from '@indicia/use-bem';

import { RealAge as RealAgeType } from '../../types';

import './RealAge.scss';

const RealAge = ({ age, realAge }: RealAgeType) => {
  const { t } = useTranslation();
  const { bemClassName } = useBem('real-age');

  return (
    <div className={bemClassName()}>
      <p>{t('dashboard.real-age.title')}</p>
      <div className={bemClassName('age')}>
        <h3 className={bemClassName('age__calculated')}>{realAge}</h3>
        <h3 className={bemClassName('age__label')}>{t('dashboard.real-age.year')}</h3>
      </div>
      <p className={bemClassName('description')}>{t('dashboard.real-age.description', { age })}</p>
    </div>
  );
};

export default RealAge;
